
export const navConstants = {
    DRAWER_OPEN: 'DRAWER_OPEN',
    DRAWER_CLOSED: "DRAWER_CLOSED",
    
}